<template>
  <div class="block">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageInfo.pageSize == null ? 100 : pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.totalCount"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'MyPagination',
  props: ['pageInfo'],
  methods: {
    handleSizeChange (val) {
      this.$emit('changePageSize', val)
      this.$options.methods.handleCurrentChange(1)
    },
    // pageNum变化事件
    handleCurrentChange (val) {
      this.$emit('changeCurrentPage', val)
    }
  }
}
</script>

<style scoped>
  .el-pagination{
    margin: 50px 0;
    text-align: right;
    display: block;
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/MyPagination.vue